import Cookies from "js-cookie";
export const socket = (win) => ({ "X-Socket-Id": win.Echo.socketId() });
export const captcha = (token, version) => ({ "x-captcha-token": token, "x-captcha-version": version });
// Reads the XSRF-TOKEN cookie rather than the <meta name="csrf-token"> tag. The cookie is
// reissued on every uncached response, so it stays correct even on a Cloudflare-cached page —
// unlike the meta tag, which gets baked into the cached HTML and goes stale for every visitor
// after the first. Laravel decrypts X-XSRF-TOKEN server-side (see VerifyCsrfToken::getTokenFromRequest).
export const csrf = () => {
    var _a;
    return ({ "X-XSRF-TOKEN": (_a = Cookies.get("XSRF-TOKEN")) !== null && _a !== void 0 ? _a : "" });
};
